import React from 'react';
import { FaChartLine, FaSearch, FaChartPie, FaTags, FaCog } from 'react-icons/fa';

export const DropdownItems = [
    {
        title: 'Monitoramento de Concorrentes',
        path: 'https://hooklab.com.br/solucoes/monitoramento-de-concorrentes',
        className: 'dropdown-link',
        icon: <FaChartLine />
    },
    {
        title: 'Monitoramento de Revendedores',
        path: 'https://hooklab.com.br/solucoes/monitoramento-de-revendedores',
        className: 'dropdown-link',
        icon: <FaSearch />
    },
    {
        title: 'Monitoramento Netshoes',
        path: 'https://hooklab.com.br/solucoes/monitoramento-netshoes',
        className: 'dropdown-link',
        icon: <FaChartPie />
    },
    {
        title: 'Precificação Dinâmica',
        path: 'https://hooklab.com.br/solucoes/precificacao-dinamica',
        className: 'dropdown-link',
        icon: <FaTags />
    },
    {
        title: 'Soluções Personalizadas',
        path: 'https://hooklab.com.br/solucoes/solucoes-personalizadas',
        className: 'dropdown-link',
        icon: <FaCog />
    }
];